// DonutChart.js
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	ArcElement,
	Tooltip,
	Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ planCompletion }) => {
	const data = {
		labels: ['Completed', 'In Progress', 'Not Started'],
		datasets: [
			{
				data: [planCompletion?.completed, planCompletion?.progress, planCompletion?.notStarted],
				backgroundColor: ['#78C000', '#B679E2', '#EC6E66'],
				borderWidth: 0,
				borderRadius: 20,
				spacing: 2,
			    hoverOffset: 0, // Disable hover effect
                 hoverBorderWidth: 0,
			},
		],
	};

	const options = {
		cutout: '70%',
		responsive: true,
		plugins: {
			legend: {
				display: false
			},
			tooltip: {
				callbacks: {
					label: function (context) {
						return `${context.label}: ${context.raw}%`;
					},
				},
			},
			
		},
		 hover: {
      mode: null, // Disable hover interactions
    },
	};

	return (
		<div style={{ width: 171, height: 171, margin: 'auto' ,borderRadius:'50%'}}>
			<Doughnut data={data} options={options} />
		</div>
	);
};

export default DonutChart;
